import { render, staticRenderFns } from "./MainDataTable.vue?vue&type=template&id=25d5f3b7"
import script from "./MainDataTable.vue?vue&type=script&lang=js"
export * from "./MainDataTable.vue?vue&type=script&lang=js"
import style0 from "./MainDataTable.vue?vue&type=style&index=0&id=25d5f3b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports